import { AetherBenefitsModal, FluidContainer } from '@atlassian/mpac-primitives';
import Telemetry from '@atlassian/mpac-telemetry';
import React, { useEffect, useLayoutEffect } from 'react';
import { EnterpriseAppsSection } from '../components/EnterpriseAppsSection';
import { FeaturedSection } from '../components/FeaturedSection';
import { Hero } from '../components/Hero';
import { Sections } from '../components/Sections';
import { TrustSignalsSection, TrustSignalsSectionSkeleton } from '../components/TrustSignalsSection';
import { FeaturedSectionWrapper, HeroWrapper, SectionWrapper } from '../HomepageCommon.styles';
import { useHomepage, useHomepageAnalytics } from '../hooks';
import { useHomePageTelemetry } from '../telemetry/useHomePageTelemetry';
import { TEST_IDS } from '../testids';
export const Homepage = () => {
  const {
    enterpriseAppsSectionData,
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  } = useHomepage();
  const {
    trackTileRenders
  } = useHomepageAnalytics();
  useEffect(() => {
    if (enterpriseAppsSectionData && sectionsData) {
      trackTileRenders(enterpriseAppsSectionData, sectionsData);
    }
  }, [enterpriseAppsSectionData, sectionsData]);
  useHomePageTelemetry({
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  });
  useLayoutEffect(() => {
    Telemetry.timeToFirstMeaningfulPaint(performance.now());
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AetherBenefitsModal, null), /*#__PURE__*/React.createElement(HeroWrapper, null, /*#__PURE__*/React.createElement(Hero, {
    heading: "Discover apps for your team",
    description: "Enhance your Atlassian products' experience with the Marketplace apps"
  })), /*#__PURE__*/React.createElement(SectionWrapper, null, /*#__PURE__*/React.createElement(FeaturedSectionWrapper, null, /*#__PURE__*/React.createElement(FeaturedSection, null))), /*#__PURE__*/React.createElement(FluidContainer, null, /*#__PURE__*/React.createElement(SectionWrapper, {
    "data-testid": TEST_IDS.SECTION_ENTERPRISE
  }, /*#__PURE__*/React.createElement(EnterpriseAppsSection, {
    isLoading: isEnterpriseAppsSectionLoading,
    isError: isEnterpriseAppsSectionLoadError,
    data: enterpriseAppsSectionData
  })), !isEnterpriseAppsSectionLoading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Sections, {
    isLoading: areSectionsLoading,
    isError: isSectionsLoadError,
    data: sectionsData
  }), /*#__PURE__*/React.createElement(SectionWrapper, null, areSectionsLoading ? /*#__PURE__*/React.createElement(TrustSignalsSectionSkeleton, null) : /*#__PURE__*/React.createElement(TrustSignalsSection, null)))));
};